import { FunctionComponent } from 'react';
import { EmptyStateProps } from './types';
import { EmptyStateWrapper } from './styles';
import images from '../../../assets';
import { useTranslation } from 'react-i18next';

const EmptyState: FunctionComponent<EmptyStateProps> = (props: EmptyStateProps) => {
    const { t } = useTranslation();
    return (
        <EmptyStateWrapper className={props.className}>
            <img
                src={images['emptyStateIcon']}
                className='empty-state-icon'
                alt='Empty state icon'
            />
            <h5>{t(props.title ?? '')}</h5>
            <p>{t(props.message ?? '')}</p>
        </EmptyStateWrapper>
    );
};

EmptyState.defaultProps = {
    title: 'No Data Found',
    message: 'It looks like there’s nothing here yet.',
    className: 'arcadis-empty-state'
};

export default EmptyState;
